export enum AuthActionTypes {
  'FETCH_GENERATE_TOKEN' = 'FETCH_GENERATE_TOKEN',
  'SET_USER_VERIFICATION' = 'SET_USER_VERIFICATION',
  'GET_USER_INFO' = 'GET_USER_INFO',
  'SET_FIRST_LOGIN' = 'SET_FIRST_LOGIN',
  'SET_USER_VERIFICATION_PHONE' = 'SET_USER_VERIFICATION_PHONE',
  'SET_USER_RE_VALIDATE' = 'SET_USER_RE_VALIDATE',
  // 'GET_DEFAULT_SHIP_TO' = 'GET_DEFAULT_SHIP_TO'
}
